// Copyright (c) 2025 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

/**
 * Advisor notification types and interfaces
 */

export type AdvisorNotificationType =
  | 'LOA_SIGNED'
  | 'LOA_COMPLETED'
  | 'LOA_DECLINED'
  | 'LOA_EXPIRED'
  | 'LOA_VOIDED'
  | 'CLIENT_REGISTERED'
  | 'RELATIONSHIP_UPDATED'
  | 'POLICY_ADDED'
  | 'POLICY_DOCUMENT_UPLOADED_BY_SUPPORT'
  | 'PROVIDER_LOA_REJECTED'
  | 'SYSTEM_ALERT';

export type NotificationReferenceType =
  | 'LOA'
  | 'RELATIONSHIP'
  | 'CLIENT'
  | 'POLICY'
  | 'POLICY_DOCUMENT'
  | 'BROKERAGE'
  | 'ADVISOR'
  | 'PROFILE';

export type NotificationStatus = 'PENDING' | 'DELIVERED' | 'READ' | 'ARCHIVED';

export interface AdvisorNotification {
  id: string;
  type: AdvisorNotificationType;
  title: string;
  message: string;
  referenceType?: NotificationReferenceType;
  referenceId?: string;
  status: NotificationStatus;
  isRead: boolean;
  readAt?: string;
  createdAt: string;
  actionUrl?: string;
  metadata?: Record<string, unknown>;
}

export interface AdvisorNotificationPage {
  content: AdvisorNotification[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
}

/**
 * Derive isRead from backend notification status.
 * READ and ARCHIVED statuses are considered "read".
 */
export const isNotificationRead = (status: NotificationStatus): boolean =>
  status === 'READ' || status === 'ARCHIVED';

export interface NotificationState {
  notifications: AdvisorNotification[];
  unreadCount: number;
  loading: boolean;
  error: string | null;
  hasMore: boolean;
  page: number;
}
